import React, { useState } from "react";

const DirectoryImageLoader = ({ src, alt, className, imgClassName }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className="flex items-center justify-center overflow-hidden aspect-[11/10]">
      <div className="w-full h-full relative">
        {loading && (
          <div
            className={`absolute inset-0 bg-gray-500 animate-pulse w-full h-full`}
          ></div>
        )}

        {src && (
          <img
            src={src}
            onLoad={() => setLoading(false)}
            alt={!loading ? alt : ""}
            className={`absolute w-full h-full transition-opacity duration-500 pointer-events-none touch-none
            ${loading ? "opacity-0" : "opacity-100"} object-contain`}
          />
        )}
      </div>
    </div>
  );
};

export default DirectoryImageLoader;
